/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { formatter } from 'src/utils/formatter';
import { isJson } from 'src/utils/isJson';
import { FRONTEND_DATE_FORMATS, UTCMoment } from 'src/utils/UTCMoment';

export const tooltipCallbacks = {
  title: (context: any): string => {
    const isValidDate = UTCMoment.utc(context?.[0]?.label).isValid();
    if (isValidDate) {
      const newDate = UTCMoment.utc(context?.[0]?.label).format(
        FRONTEND_DATE_FORMATS.TOOLTIP_CHART,
      );
      return newDate;
    }
    return context.label;
  },
  label: (context: any): string => {
    const isJsonLabelData = isJson(context.dataset.label);
    if (isJsonLabelData) {
      // eslint-disable-next-line prefer-const
      const { unit, currency, title } = JSON.parse(context.dataset.label);

      // if (title === 'Community') {
      //   title = 'Grid Market';
      // }

      if (context.parsed.y && title === 'Energy Bought' && unit) {
        return `${title}: ` + context.parsed.y + ` ${unit}`;
      }

      if (currency) {
        const currencySymbol = formatter.getCurrencySymbol(context.dataset.label.split('/')[0]);
        return `${title}: ` + context.formattedValue + ` ${currencySymbol} ${unit && `/ ${unit}`}`;
      }
      return `${title}: ` + context.formattedValue + ` ${unit}`;
    } else {
      return context.formattedValue;
    }
  },
};
